module.exports = __webpack_public_path__ + "static/media/r-md19.aa7909c6.png";